<template>
  <div class="transaction-item">
    <div class="transaction-details">
      <div class="basic-info">
        <div class="">
          <span class="transaction-date">{{ txDate }}</span> <span class="source">{{ source }}</span>  
        </div>
        <div class="building-name">{{ name }}</div>
        <div class="" v-if="icsType === 's'">
          <div 
            v-for="(area, index) in area.zh"
            class="area-shop">
            <span class="area-desc">{{ area.desc }}</span>
            <span class="area-value">{{ fmt(area.value) }}</span>
            <span class="feet">{{ $t('transaction.SQFT') }}</span>
          </div>
          <div 
            v-if="area.zh.length === 0"
            class="area-shop">
            -
          </div>
        </div>
        <div class="" v-else>
          <span class="area-value">{{ fmt(area.value) }}</span>
          <span class="feet">{{ $t('transaction.SQFT') }}</span>
        </div>
      </div>

      <div class="price-info">
        <div class="">
          <span class="tx-type" :class="[ txClass ]">
            {{ txType === 'S'? $t('transaction.SOLD') : $t('transaction.LEASED') }}
          </span>
        </div>
        <div class="">
          <span class="price-feet-value">{{ priceFeet }}</span> / {{ $t('transaction.SQFT') }}
        </div>
        <div class="">
          <span class="price-total-value">${{ priceTotal }}</span>
        </div>
        <div class="" v-if="stockSearchButton">
          <link-button 
            :icsType="icsType"
            :targetLink="stockLink"
            :buttonText="$t('transaction.LATEST_STOCK')"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import numberFormat from '@/mixins/numberFormat';
import LinkButton from '@/components/LinkButton';

export default {
  props: [
    'txDate',
    'source',
    'name',
    'area',
    'icsType',
    'txType',
    'priceFeet',
    'priceTotal',
    'stockLink',
    'stockSearchButton',
  ],
  mixins: [numberFormat],
  components: {
    LinkButton,
  },
  computed: {
    txClass() {
      return this.txType === 'S' ? 'tx-type-sold' : 'tx-type-leased';
    },
  },
};
</script>

<style scoped>
.transaction-item {
  padding: 14px 15px;
  margin: 0 -15px;
}

.transaction-details {
  display: flex;
}
.transaction-details .basic-info {
  flex: 1 1 auto;  
}
.transaction-details .price-info {  
  flex: 0 0 130px;
  text-align: right;
}

.transaction-date, .source, .tx-type {
  font-size: 1rem;
}
.building-name {
  font-size: 1.375rem;
}
.tx-type {
  padding: 3px;
  background-color: #eee;
}
.area-value, .price-feet-value, .price-total-value { 
  font-size: 1.5rem;
}
</style>